import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/animations.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/directus.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/backOfficeDiscussions.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/react-paginate.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/generic.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/reactflow/dist/style.css");
